<div *ngIf="(global.globalAgencyId==null ||global.globalAgencyId==undefined ||
global.globalAgencyId=='' || global.globalAgencyId=='00000000-0000-0000-0000-000000000000')">
    <div class="row mb-2">
        <div class="col p-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-body  widget-body pt-2">
                    <div class="text-center text-danger">
                        <label class="font-red"><i class="fa fa-info-circle fa-lg"></i>&nbsp;Select agency to view
                            details</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
<div class="row mt-2 mb-3">
    <h4 class="mb-2 py-1 font-header-1">Purchase Verification</h4>
</div>
    <div class=" mb-2">
        <div class="col p-0">
            <div widget class="card border-0 box-shadow">
                

                <!-- Filters Feilds-->
                <div class="card-body mt-2">
                    <!-- start Date & end date Filter -->
                    <div class="row">
                        <div class="col-lg-4 ">
                            <div class="row">
                                <div class="col-lg-4  ">
                                    <label class="label-font">Start date</label>
                                </div>

                                <div class="col-lg-8 col-11 ">
                                    <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                        [selDate]="fromDate"
                                        (inputFieldChanged)="DateFormat($event,'inputchanged','FromDate')"
                                        (dateChanged)="DateFormat($event,'datechanged','FromDate')">
                                    </my-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4  ">
                            <div class="row">
                                <div class="col-lg-4  ">
                                    <label class="label-font">End date</label>
                                </div>
                                <div class="col-lg-8 col-11 ">
                                    <my-date-picker [options]="myDatePickerOptions" placeholder="mm/dd/yyyy"
                                        [selDate]="toDate"
                                        (inputFieldChanged)="DateFormat($event,'inputchanged','ToDate')"
                                        (dateChanged)="DateFormat($event,'datechanged','ToDate')">
                                    </my-date-picker>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="row">
                                <div class="col-lg-4">
                                    <label class="label-font">Client</label>
                                </div>
                                <div class="col-lg-8 col-11">
                                    <ng-select [searchable]="true" [(ngModel)]="TimesheetGridList.clientId"
                                        [clearable]="true" bindLabel="Value" bindValue="Key" [items]="AllClientList">
                                    </ng-select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- CLient & employee Filter -->
                    <div class="row mt-2">
                        
                        <div class="col-lg-4">
                            <!-- <div class="row">
                                <div class="col-lg-4">
                                    <label class=" label-font">Employee</label>
                                </div>
                                <div class="col-lg-8 col-11 ">
                                    <ng-select [searchable]="true" [(ngModel)]="TimesheetGridList.employeeid"
                                        [clearable]="true" bindLabel="Value" bindValue="Key" [items]="AllEmployeeList">
                                    </ng-select>
                                </div>
                            </div> -->
                        </div>
                        <div class="text-end mt-2">
                            <div >
                                <button type="button" class="btn btn-sm" (click)="filterApply()">Apply
                                </button>
                                <button type="button" class="btn btn-sm ms-lg-5 ms-3" (click)="Refresh()">Refresh
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>






<div class="row mb-2" *ngIf="(global.globalAgencyId!=null && global.globalAgencyId!=undefined  &&
global.globalAgencyId!=''&& global.globalAgencyId!='00000000-0000-0000-0000-000000000000')">
    <div class=" mb-2">
        <div class="col p-0">
            <div widget class="card border-0 box-shadow">
                <div class="card-header transparent  text-muted">
                    <div class="row my-1">
                        <div class="col-lg-4 col-12 d-flex  my-2">
                            <div class="">
                                <button type="button" class="btn btn-sm" (click)="selecttobill()"  *ngIf="fp.purchasereqversendtobill"
                                    [disabled]="selecteddata?.length==0 || global.checkProgressPurchase">Send To Bill
                                </button>
                            </div>
                            <!-- <div class="mx-5">
                                <button type="button" class="btn_m"><span>Move To Archive</span>
                                   
                                </button>

                            </div> -->
                            <!-- <div class="">
                                <button type="button" class="btn_m" (click)="ExportExcelTimesheetVerification()">Export as Excel
                                </button>
                            </div> -->

                        </div>
                        <!-- <div class="row col-lg-8 col-12 my-2 mt">
                            <div class="col-3 text-lg-center mt-1">
                                <label class="label-font ">Show Claim Status</label>
                            </div>
                            <div class="col-3">
                               
                                <ng-select [searchable]="true" [(ngModel)]="claimStatusFilter" [clearable]="true"
                                    bindLabel="Value" bindValue="Key" [items]="ClaimStatusList" (ngModelChange)="claimStatusFilterfun()">
                                </ng-select>
                            </div>
                        </div> -->

                    </div>

                </div>
                <div class="card-body p-0">

                    <!-- <div class="row mb-2">
                        <div class="col p-0">
                            <div widget class="card border-0 box-shadow" >
                                <div class="row">
                                    <div class="col-lg-12 col-md-12"> -->
                    <!-- <nav *ngIf="!global.docbool">
                                            <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
                                                
                                                <a class="nav-item nav-link active" id="nav-active-tab"
                                                    data-bs-toggle="tab" href="#nav-active" role="tab"
                                                    aria-controls="nav-active" aria-selected="true"
                                                    (click)="getActiveTab('active')">Active</a>
                                                <a class="nav-item nav-link" id="nav-archive-tab" data-bs-toggle="tab"
                                                    href="#nav-archive" role="tab" aria-controls="nav-archive"
                                                    aria-selected="true" (click)="getActiveTab('archive')">Archive</a>
                                            </div>
                                        </nav> -->
                    <!-- <div class="tab-content" id="nav-tabContent"> -->

                    <!-- <div *ngIf="activeTab=='active'">
                                                <div class="tab-pane fade  " id="nav-active" role="tabpanel"
                                                    aria-labelledby="nav-active"
                                                    [ngClass]="{'active':activeTab=='active','show':activeTab=='active'}"> -->

                    <!-- ejs-grid -->
                    <div class="my-3 px-1">
                        <!-- <ejs-grid #gridTimesheetV [dataSource]='GridTimesheetVList | async' [allowPaging]="true" [allowSorting]="true"
                        [allowFiltering]="true" [allowGrouping]="true" [pageSettings]='initialPage'> -->
                        <ejs-grid #gridTimesheetV [dataSource]='GridTimesheetVList | async' [allowResizing]='true'
                            [allowSorting]='true' [allowPaging]='true' [allowFiltering]='true'
                            [showColumnChooser]='true' [pageSettings]='initialPage'
                            (checkBoxChange)="CheckBoxClickEvent($event)" [filterSettings]='filterOptions'
                            [selectionSettings]='selectionOptions' (cellEdit)="cellEdit($event)"
                            (rowDataBound)='rowDataBound($event)' [textWrapSettings]='wrapSettings'
                            (dataStateChange)='dataStateChange($event)' (actionBegin)="onActionComplete($event)"
                            (queryCellInfo)='validatebutton($event)'>
                            <!-- 
                                  (toolbarclick)="getdata($event)" (resizeStop)="onResize($event)"-->
                            <e-columns>
                                <e-column type='checkbox' [showInColumnChooser]='false'  maxWidth=80
                                    [allowEditing]='true'  [edit]='checkparams'
                                    textAlign='center'></e-column>
                                <e-column field='claimStatus' headerText="Claim Status" textAlign='center' minWidth=80
                                    [allowEditing]='false' type='string' [allowFiltering]="false">
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column field='validate' headerText="Validate" minWidth=80 textAlign='center'
                                    [allowEditing]='false' [allowFiltering]="false" [allowSorting]='false'>
                                    <ng-template #template let-data>
                                        <div>
                                            <button class="" data-bs-toggle="modal" data-bs-target="#showerror"
                                                (click)="showerrors($event)"
                                               >Validate</button>
                                               <!-- [class.btn_colorRed]="data.claimStatus=='Validate'"
                                               [class.btn_color]="data.claimStatus=='Ready'" -->
                                        </div>
                                    </ng-template>
                                </e-column>

                                <!-- <e-column field='errorNotes' headerText="Error Notes" minWidth='120' textAlign='center'
                                    [allowEditing]='false' type='string' [allowSorting]='false'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column> -->

                                <e-column field='client_Name' headerText="Client Name" textAlign='center' minWidth='80'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                
                                <e-column field='payer_PayorName' headerText="Payer Name" textAlign='center' minWidth=80
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>
                                <e-column field='serviceCodeToDisplay' headerText="Service Name" textAlign='center' minWidth=80
                                [allowEditing]='false' type='string'>
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>
                               
                                <e-column field='purchaseRequestDate' headerText="Purchase Date" minWidth='80'
                                    textAlign='center' [format]='formatOptions' [allowEditing]='false' type='date'
                                    [allowFiltering]='false'>
                                </e-column>
                                <e-column field='rate' headerText="Pay Rate" textAlign='center' minWidth=80
                                [allowEditing]='false' type='string'>
                                <ng-template #filterTemplate let-data>
                                    <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                </ng-template>
                            </e-column>

                                <e-column field='quantity' headerText="Quantity" minWidth=80 textAlign='center'
                                    [allowEditing]='false' type='string'>
                                    <ng-template #filterTemplate let-data>
                                        <ejs-maskedtextbox placeholder="Enter the value"></ejs-maskedtextbox>
                                    </ng-template>
                                </e-column>

                                <e-column field='billingAmount' headerText="Total Amount" minWidth=80 textAlign='center'
                                    [allowEditing]='false' [allowFiltering]='false' type='number'></e-column>

                               
                                <e-column width="50" [showInColumnChooser]='false'>
                                    <ng-template #headerTemplate let-data>
                                        <div>
                                            <span id='show' (click)='showTimesheetColumns()'><i class="fa fa-cog fa-lg"
                                                    aria-hidden="true"> </i></span>
                                        </div>
                                    </ng-template>
                                </e-column>

                            </e-columns>
                        </ejs-grid>

                    </div>
                    <!-- </div>
                                            </div> -->
                    <!-- <div *ngIf="activeTab=='archive'">
                                                <div class="tab-pane fade  " id="nav-archive" role="tabpanel"
                                                    aria-labelledby="nav-archive"
                                                    [ngClass]="{'active':activeTab=='archive','show':activeTab=='archive'}">
                                                </div>
                                            </div> -->
                </div>
            </div>
        </div>
    </div>
</div>
<!-- </div>
                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> -->

<span id="OpenModal2" data-bs-target="#showerror" data-bs-toggle="modal"></span>
<div class="modal fade" id="showerror" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">

    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content" style="width:700px;">
            <div class="modal-header">
                <label class="font-header fs-5">Check Validation Status</label>
                <button class="btn-close" type="button" data-bs-dismiss="modal" (click)="colseerr()"></button>
            </div>
            <div class="modal-body">
                <div class="container scrolltbody">
                    <div class="mb-2 d-flex ms-4 ps-3">
                        <input type="checkbox" class="mr-2 mt-1" [(ngModel)]="isEnabled" (change)="SelectErrorData()" />

                        <label for="radio-1" class="mt-1 d-flex ms-2" [class.textcolor]="isEnabled">Show errors
                            only</label>
                    </div>
                    <div class="d-flex justify-content-center">
                        <table class="table table-responsive table-hover table-bordered ms-0" style="width:600px;">
                            <thead style="background: #00786a;height: 25px;">

                                <th style="width: 200px;font-size:15px;" class="pointer text-center">Column</th>
                                <th style="width: 150px;font-size:15px;" class="pointer text-center">Status</th>

                            </thead>
                            <tbody>
                                <tr *ngFor="let c of showerrolist" class="row1">


                                    <td [style.color]="c.color" class="row1 font-weight textSize">
                                        {{c.columnName}} </td>
                                    <!-- (click)="abc(c.columnName,c.color)" -->

                                    <td [style.color]="c.colr" class="text-center textSize">{{c.status}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button class="btn blue-btn btn-sm  text-right" type="button" (click)="colseerr()">
                    Close</button>
            </div>
        </div>
    </div>
</div>


<!-- <span id="OpenModapayer" data-bs-target="#Modalpayer" data-bs-toggle="modal"></span>
<div class="modal fade" id="Modalpayer" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
    aria-hidden="true" data-bs-backdrop="static">

    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button class="btn-close" type="button" data-bs-dismiss="modal" (click)="getTimesheetVList();"></button>
            </div>
            <div class="modal-body">
                <app-payer *ngIf="emitpayer.TimsheetV_payer" [emitpayerTimsheetV]="emitpayer"></app-payer>
            </div>
        </div>
    </div>
</div> -->



 
   

